import { Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material';
import * as moment from 'moment';
import { Moment } from 'moment';
import { TimesheetService } from '../../pages/timesheets/providers/timesheet.service';

/**
 * Generated class for the WeekSelectorComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'week-selector',
  templateUrl: 'week-selector.html'
})
export class WeekSelectorComponent implements OnInit {

  public currentWeekNumber: number;
  public currentYear: number;
  public daysOfWeek = moment.weekdaysShort( true );
  public daysOfTimesheet: Date[] = [];

  @Output() dateChange: EventEmitter<Moment> = new EventEmitter();

  /**
   * Wire the arrow keys to this component
   * @param {KeyboardEvent} event The input event
   */
  @HostListener('window:keyup', ['$event'] )
  keyEvent( event: KeyboardEvent ): void {

    // const notInputTarget = event.target[ 'type' ] === undefined || event.target[ 'type' ] !== 'number';

    if ( event.keyCode === 39 ) { // Right arrow key
      this.nextWeek( this.currentWeekNumber );
    }

    if ( event.keyCode === 37 ) { // Left arrow key
      this.previousWeek( this.currentWeekNumber );
    }
  }

  constructor(
    public $timesheetService: TimesheetService,
  ) {

  }

 /**
   * @param {MatDatepickerInputEvent} event Change to newly selected date
   */
  public changeDate( event: MatDatepickerInputEvent<Date> ) {
    const newMoment = moment( event.value );
    this.currentWeekNumber = newMoment.isoWeek();
    this.currentYear = newMoment.isoWeekYear();

    this._changeDate( newMoment );

    this.setWeek( newMoment.isoWeek(), newMoment.isoWeekYear() );
    console.log( '[USER-SELECTOR] Change date', newMoment.format() );
  }

  /**
   * @param {number} currentWeek Select previous week based on this week
   */
  public previousWeek( currentWeek: number ) {
    let newMoment = moment().isoWeekYear( this.currentYear ).isoWeek( currentWeek ).subtract( 1, 'week' );
    this.setWeek( newMoment.isoWeek(), newMoment.isoWeekYear() );

    this._changeDate( newMoment );
  }

  /**
   * @param {number} currentWeek Select next week based on this week
   */
  public nextWeek( currentWeek: number ) {
    let newMoment = moment().isoWeekYear( this.currentYear ).isoWeek( currentWeek ).add( 1, 'week' );
    this.setWeek( newMoment.isoWeek(), newMoment.isoWeekYear() );

    this._changeDate( newMoment );
  }

  /**
   * @param currentWeek
   */
  public setWeek( currentWeek: number, currentYear: number ): Moment {

    let isoWeek = moment().isoWeekYear( currentYear );
    isoWeek = isoWeek.isoWeek( currentWeek );
    isoWeek = isoWeek.startOf( 'isoWeek' );
    this.currentWeekNumber = isoWeek.isoWeek();
    this.currentYear = isoWeek.isoWeekYear();
    let copyOfIsoWeek = isoWeek.clone();

    this.daysOfTimesheet.length = 0;

    for ( let i = 0; i<= 6; i++ ) {
      this.daysOfTimesheet.push( copyOfIsoWeek.toDate() );
      copyOfIsoWeek = copyOfIsoWeek.add( 1, 'day' );
    }

    return isoWeek;
  }

  ngOnInit() {
    const localStorageData = this.$timesheetService.getStoredTimesheetData();

    // Determine selected week and year
    //
    if ( localStorageData.isoWeek && localStorageData.year )
    {
      this.currentWeekNumber = localStorageData.isoWeek;
      this.currentYear = localStorageData.year;
    } else
    {
      const now = moment();
      this.currentWeekNumber = now.isoWeek();
      this.currentYear = now.isoWeekYear();
    }
  }

  private _changeDate( date: Moment ) {
    this.dateChange.emit( date );
    this.$timesheetService.storeSelectedWeek( date.isoWeekYear(), date.isoWeek() );
  }
}



// WEBPACK FOOTER //
// ./src/components/week-selector/week-selector.ts